import { FC } from "react";

import { I18nKeyType } from "@/i18n";

import { DriverFlowBottomButtonPropsType } from "../blocks";
import { DsSelectBox, DsSelectBoxPropsType } from "../components/ui";
import { JobServiceTaskBaseType } from "../domain/task";
import { DriverStepScreenWrapper } from "./DriverStepScreenWrapper";

type DriverScreenWithSelectBoxPropsType = JobServiceTaskBaseType & {
  title: I18nKeyType;
  titlei18nOptions?: object;
  bottomButtonProps: DriverFlowBottomButtonPropsType;
  selectBoxProps: DsSelectBoxPropsType;
  isLoading?: boolean;
};

const DriverScreenWithSelectBox: FC<DriverScreenWithSelectBoxPropsType> = ({
  title,
  titlei18nOptions,
  jobId,
  serviceId,
  taskId,
  bottomButtonProps,
  selectBoxProps,
  isLoading,
}) => {
  return (
    <DriverStepScreenWrapper
      jobId={jobId}
      serviceId={serviceId}
      taskId={taskId}
      title={title}
      isLoading={isLoading}
      titlei18nOptions={titlei18nOptions}
      {...bottomButtonProps}>
      <DsSelectBox {...selectBoxProps} />
    </DriverStepScreenWrapper>
  );
};

export { DriverScreenWithSelectBox };
